import Auth from './Auth';
import Toast from './General/Toast';

const reducers = {
    Auth,
    Toast
};

export default reducers;
